export class MonitoringApiClient {
  constructor(client) {
    this.client = client
  }

  getMonitoringData = (params) => {
    return this.client.get('/admin/v1/monitoring', { params }).then((response) => response.data)
  }
  disconnectProfessional = (professionalId, status) => {
    return this.client
      .put(`admin/v1/professionals/${professionalId}/change-status`, { status: status })
      .then((response) => response.data)
  }
}

export default MonitoringApiClient
